import { Button, Modal } from "antd";
import React from "react";

function ConfirmationModal(props) {
  function handleOk() {
    props.handleOk();
    props.handleCancel();
  }
  return (
    <Modal
      title={props.title}
      visible={props.visible}
      onOk={() => handleOk()}
      onCancel={props.handleCancel}
      footer={null}
      width={370}
    >
      <div className="mb-6">{props.text}</div>
      <div className="flex justify-end">
        <Button className="mr-3 w-20" onClick={props.handleCancel}>
          No
        </Button>
        <Button className="w-20" type="primary" onClick={() => handleOk()}>
          Yes
        </Button>
      </div>
    </Modal>
  );
}

export default ConfirmationModal;
